import {useState} from "react";
import {gql, useMutation, useSubscription} from "@apollo/client";
import {Button, Descriptions, Form, Input, Radio, Select, DatePicker} from "antd";
import {bigIntMoney10000ToString, money10000ToString, string10000ToMoney} from "./Utils";
import {企业填报人签字日期, 研究开发费用明细字段} from "./config";

const {TextArea} = Input;
const dayjs = require('dayjs')
export default function Kffymx() {
    const [value, setValue] = useState(window.location.hash.split("?")[1] || '');

    const handleChange = (newValue) => {
        setValue(newValue);
        window.location.hash = (window.location.hash.split("?")[0] || window.location.hash) + '?' + newValue
    };
    const [form] = Form.useForm();
    const {data: theRDData, loading: theMndsbDataLoading} = useSubscription(
        gql`subscription MySubscription($id: uuid = "") {
            kffymx_by_pk(id: $id) {
                created_at
                fillUser
                fillUserDate
                id
                mndsb
                nbyjkftr
                nwhj
                orderNo
                pjnwbtrhj
                qtfy
                ryrg
                sbtsf
                sjf
                updated_at
                wtwbyjkftr
                wxzc
                xmbh
                zjfy
                zjtr
                yearsAgo
                mndsbObj {
                    _glykj
                    _jscxgl
                    _kjcgzh
                    _zscqjz
                    basics_cost
                    china_cost
                    company
                    created_at
                    ent_hr_abroed
                    ent_hr_age1
                    ent_hr_age2
                    ent_hr_age3
                    ent_hr_age4
                    ent_hr_bachelor
                    ent_hr_doctor
                    ent_hr_ext
                    ent_hr_forg
                    ent_hr_junior
                    ent_hr_master
                    ent_hr_mechanic
                    ent_hr_middle
                    ent_hr_on_job
                    ent_hr_part
                    ent_hr_primary
                    ent_hr_senior
                    ent_hr_total
                    ent_hr_tsdplan
                    enterprise_income
                    id
                    net_asset1
                    net_asset2
                    net_asset3
                    sales_revenue1
                    sales_revenue2
                    sales_revenue3
                    sat_hr_abroed
                    sat_hr_ext
                    sat_hr_forg
                    sat_hr_on_job
                    sat_hr_part
                    sat_hr_total
                    year
                    updated_at
                    total_profit3
                    total_profit2
                    total_profit1
                    sat_hr_tsdplan
                    zccqhzs {
                        created_at
                        id
                        mndsb
                        propertyAccredit
                        propertyCategory
                        propertyName
                        propertyNo
                        propertyWay
                        txtDate
                        updated_at
                    }
                    gxjscps {
                        PGjjszb
                        PJzys
                        PZscqqk
                        Psfzycpstatus
                        cod
                        created_at
                        id
                        mndsb
                        productName
                        shr
                        technologyS
                        updated_at
                    }
                    companyObj {
                        updated_at
                        tyshxydm
                        qymc
                        id
                        created_at
                        clsj
                    }
                    kffymxs {
                        created_at
                        fillUser
                        fillUserDate
                        id
                        mndsb
                        nbyjkftr
                        nwhj
                        orderNo
                        pjnwbtrhj
                        qtfy
                        ryrg
                        sbtsf
                        sjf
                        updated_at
                        wtwbyjkftr
                        wxzc
                        xmbh
                        zjfy
                        zjtr
                    }
                }
            }
        }
        `, {
            variables: {id: value},
            shouldResubscribe: true
        },
    )
    const [update_kffymx_by_pk, {error}] = useMutation(gql`mutation MyMutation($id: uuid = "", $kffymx: kffymx_set_input = {}) {
        update_kffymx_by_pk(pk_columns: {id: $id}, _set: $kffymx) {
            id
        }
    }
    `);
    const kffymxInitialValues = {...(theRDData || {}).kffymx_by_pk};
    if ((theRDData || {}).kffymx_by_pk) {
        for (let k of 企业填报人签字日期) {
            if ((theRDData || {}).kffymx_by_pk[k]) {
                kffymxInitialValues[k] = dayjs((theRDData || {}).kffymx_by_pk[k])
            }
        }
        for (let k of 研究开发费用明细字段) {
            if ((theRDData || {}).kffymx_by_pk[k]) {
                kffymxInitialValues[k] = money10000ToString((theRDData || {}).kffymx_by_pk[k])
            }
        }
    }

    return (<>
        {(theRDData || {}).kffymx_by_pk && <>
            <div style={{padding: '10px'}}></div>
            <Form
                name="basic"
                labelCol={{
                    span: 32,
                }}
                wrapperCol={{
                    span: 32,
                }}
                style={{
                    maxWidth: 800,
                }}
                initialValues={kffymxInitialValues}
                onFinish={(values) => {
                    console.log(values)
                    for (let k of 研究开发费用明细字段) {
                        if (values[k]) {
                            values[k] = string10000ToMoney(values[k])
                        }
                    }


                    update_kffymx_by_pk({
                        variables: {
                            id: value,
                            kffymx: values
                        }
                    }).fankui().then(value1 => window.history.back())
                    // insert_mndsb({variables: {year: e.year.$y, company: theCompanyData.company[0].id}})
                }}
                onFinishFailed={(e) => {
                    console.error(e)
                }}
                autoComplete="off"
                form={form}
            >
                {/*<Form.Item*/}
                {/*    label="项目编号 "*/}
                {/*    name="xmbh"*/}
                {/*    rules={[{required: true, message: '请输入内容'}]}*/}

                {/*>*/}
                {/*    <Select>*/}
                {/*        <Select.Option value="0">请选择</Select.Option>*/}
                {/*    </Select>*/}
                {/*</Form.Item>*/}
                <Form.Item
                    label="内部研究开发费用（万元） "
                >
                    <div>
                        <Form.Item
                            label="共计（万元）"
                            name="nbyjkftr"
                            rules={[{required: true, message: '请输入内容'}]}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            label="其中：人员人工费用（万元）"
                            name="ryrg"
                            rules={[{required: true, message: '请输入内容'}]}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            label="直接投入费用（万元）"
                            name="zjtr"
                            rules={[{required: true, message: '请输入内容'}]}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            label="折旧费用与长期待摊费用（万元）"
                            name="zjfy"
                            rules={[{required: true, message: '请输入内容'}]}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            label="无形资产摊销费用（万元）"
                            name="wxzc"
                            rules={[{required: true, message: '请输入内容'}]}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            label="设计费用（万元）"
                            name="sjf"
                            rules={[{required: true, message: '请输入内容'}]}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            label="装备调试费用与试验费用（万元）"
                            name="sbtsf"
                            rules={[{required: true, message: '请输入内容'}]}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            label="其他费用（万元）"
                            name="qtfy"
                            rules={[{required: true, message: '请输入内容'}]}
                        >
                            <Input/>
                        </Form.Item>

                    </div>
                </Form.Item>
                <Form.Item
                    label="委托外部研究开发费用（万元）"
                >
                    <div>
                        <Form.Item
                            label="共计（万元）"
                            name="wtwbyjkftr"
                            rules={[{required: true, message: '请输入内容'}]}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            label="其中：境内的外部研发费用"
                            name="pjnwbtrhj"
                            rules={[{required: true, message: '请输入内容'}]}
                        >
                            <Input/>
                        </Form.Item>
                    </div>
                </Form.Item>
                <Form.Item
                    label="研究开发费用（内、外部）小计（万元）"
                >
                    <div>
                        <Form.Item
                            label="共计（万元）"
                            name="nwhj"
                            rules={[{required: true, message: '请输入内容'}]}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            label="企业填报人"
                            name="fillUser"
                            rules={[{required: true, message: '请输入内容'}]}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            label="企业填报人签字日期"
                            name="fillUserDate"
                            rules={[{required: true, message: '请输入内容'}]}
                        >
                            <DatePicker/>
                        </Form.Item>
                        <Form.Item
                            label="排序号"
                            name="orderNo"
                            rules={[{required: true, message: '请输入内容'}]}
                        >
                            <Input/>
                        </Form.Item>

                    </div>
                </Form.Item>
                <Form.Item wrapperCol={{offset: 8, span: 8}}>
                    <Button type="primary" htmlType="submit">
                        确定
                    </Button>
                </Form.Item>
            </Form>


        </>}
    </>)
}
